import { render, staticRenderFns } from "./ContractRbuSectionFluctuationModule.vue?vue&type=template&id=2c5257c2"
import script from "./ContractRbuSectionFluctuationModule.vue?vue&type=script&lang=js"
export * from "./ContractRbuSectionFluctuationModule.vue?vue&type=script&lang=js"
import style0 from "./ContractRbuSectionFluctuationModule.vue?vue&type=style&index=0&id=2c5257c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports